'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AccessRuleCreatePage, SETTINGS_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/access-rules/new/')({
  component: () => <AccessRuleCreatePage paths={SETTINGS_AUTH_POLICY_PATHS} />
});